export default __webpack_public_path__ + "static/media/add_box.ee06f94c.svg";